import Image from "next/image";
import React from "react";

import Book from "assets/iconsv2/book-16.svg";
import Layers from "assets/iconsv2/layers-16.svg";
import Important from "assets/iconsv2/important-03-16.svg";
import ComputerChip from "assets/iconsv2/computer-chip-16.svg";
import ArrowRight from "assets/icons/arrow-right.svg";
import extendYourInternalProcesses from "assets/teams/extend-your-internal-processes.png";
import employeeIndexFrame from "assets/teams/employee-index-frame.png";
import brandAssetsFrame from "assets/teams/brand-assets-frame.png";
import reportBugsFrame from "assets/teams/report-bugs-frame.png";

import TeamsHighlight from "./TeamsHighlight";
import ExtensionsSlideshow from "./ExtensionsSlideshow";
import styles from "./TeamsPrivateExtensions.module.css";

const TeamsPrivateExtensions: React.FC = () => {
  const slides = [
    <Image
      alt="Employee Index Frame"
      src={employeeIndexFrame}
      width={846}
      height={571}
      layout="fixed"
      quality={100}
      key={1}
      unoptimized
      priority
    />,
    <Image
      alt="Employee Index Frame"
      src={brandAssetsFrame}
      width={846}
      height={571}
      layout="fixed"
      quality={100}
      key={2}
      unoptimized
      priority
    />,
    <Image
      alt="Employee Index Frame"
      src={reportBugsFrame}
      width={846}
      height={571}
      layout="fixed"
      quality={100}
      key={3}
      unoptimized
      priority
    />,
  ];

  const anchors = [
    <>
      <i>
        <Book className="icon" />
      </i>
      <strong>Employee Index</strong>
      <p>Stay on top of your growing company by making it easy to search, and get to know, your teammates.</p>
    </>,
    <>
      <i>
        <Layers className="icon" />
      </i>
      <strong>Brand assets</strong>
      <p>
        Keep your visuals consistently on-brand with easily accessible colors, icons, screenshots and more, for the
        whole team.
      </p>
    </>,
    <>
      <i>
        <Important className="icon" />
      </i>
      <strong>Report bugs</strong>
      <p>
        Set up template bug report forms to give timely and actionable feedback on features and projects in development.
      </p>
    </>,
  ];

  return (
    <>
      <TeamsHighlight
        dir="ltr"
        img={
          <Image
            alt="Extend your internal processes"
            src={extendYourInternalProcesses}
            sizes="(max-width: 840px) 342px, 846px"
            layout="responsive"
          />
        }
      >
        <strong>
          <ComputerChip className="icon" />
          Private Extensions
        </strong>

        <h4>Unlock your team&rsquo;s potential with custom extensions</h4>
        <p>
          With great teams come great processes. Using our developer API, create and publish extensions to your
          organization&rsquo;s Private Extension Store for your team to install.
        </p>
        <p>
          Build extensions to quickly access company brand assets, log feedback, book time off, or search your employee
          index.
        </p>

        <a href="https://developers.raycast.com/teams-beta/getting-started" target="_blank" rel="noreferrer">
          Read the docs <ArrowRight className="icon" />
        </a>
      </TeamsHighlight>

      <div className={styles.slideshowContainer}>
        <ExtensionsSlideshow
          slides={slides}
          anchors={anchors}
          gradients={[
            "linear-gradient(112.7deg, #3e74ff 0%, #5505ff 39.49%, #020207 100%)",
            "linear-gradient(77.27deg, #020207 0%, #5505FF 39.49%, #4DBFCE 100%)",
            "linear-gradient(292.7deg, #070202 0%, #7E1DCB 39.49%, #4DBFCE 100%)",
          ]}
        />
      </div>
    </>
  );
};

export default TeamsPrivateExtensions;
